import { useEffect } from "react";

interface LightboxProps {
  src: string;
  alt: string;
  onClose: () => void;
}

export default function Lightbox({ src, alt, onClose }: LightboxProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-background-950/90 p-4 backdrop-blur-sm animate-fade-in"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="图片预览"
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-md border border-background-600 text-foreground-100 transition-colors hover:border-accent-400 hover:text-accent-400"
        aria-label="关闭预览"
      >
        <i className="ri-close-line text-2xl"></i>
      </button>
      <figure className="max-h-[85vh] max-w-5xl" onClick={(e) => e.stopPropagation()}>
        <img
          src={src}
          alt={alt}
          title={alt}
          className="max-h-[78vh] w-full rounded-lg object-contain"
        />
        <figcaption className="mt-3 text-center font-label text-sm text-foreground-400">
          {alt}
        </figcaption>
      </figure>
    </div>
  );
}